import Vue from 'vue';

const state = {
  ticketNotes: {}
}

const getters = {

  ticketNote (state) {
    return id => {
      if (id in state.ticketNotes) return state.ticketNotes[id];
      else return false;
    }
  },

  ticketNotes (state) {
    return state.ticketNotes;
  }
}

const mutations = {

  storeTicketNotes (state, ticketNotes) {
    ticketNotes.forEach(note => {
      var current = state.ticketNotes[note._id] || {};
      Vue.set(state.ticketNotes, note._id, {
        ...current,
        ...note
      });
    });
  },

  removeTicketNote (state, id) {
    if (id in state.ticketNotes) Vue.delete(state.ticketNotes, id);
  },

  clearTicketNotes () {
    Vue.set(state, 'ticketNotes', {});
  }

}


const actions = {
  
  storeTicketNoteLiveUpdate ({commit}, data) {
    var result = storeData([data]);
    commit('storeUsers',        result.users);
    commit('storeTicketNotes',  result.ticketNotes);
  },

  loadTicketNotes ({commit}, params) {

    if (!params.property || !params.ticket) {
      return reject('state.ticketNote - loading Ticket Notes Missing required parameter - property: ' + !params.property + ', ticket: ' + !params.ticket);
    }

    var filters = params.filters || {};

    var queryParams = {
      ...filters,
      ...{
        populateUser: true
      }
    };

    return window.server.getReq('property/' + params.property + '/ticket/' + params.ticket._id + '/notes', {
      params: queryParams
    })
    .then(data => {
      var result = storeData(data);
      commit('storeUsers',        result.users);
      commit('storeTicketNotes',  result.ticketNotes);
      return Promise.resolve(result.ticketNotes);
    })
    .catch(e => {
      console.log('state - tickets - actions.loadTicketNotes Error:', e);
      return Promise.reject(e);
    });
  },

  loadTicketNotes ({commit}, params) {

    if (!params.property || !params.ticket) {
      return reject('state.ticketNote - loading Ticket Notes Missing required parameter - property: ' + !params.property + ', ticket: ' + !params.ticket);
    }

    var filters = params.filters || {};

    var queryParams = {
      ...filters,
      ...{
        populateUser: true
      }
    };

    return window.server.getReq('property/' + params.property + '/ticket/' + params.ticket._id + '/notes', {
      params: queryParams
    })
    .then(data => {
      var result = storeData(data);
      commit('storeUsers',        result.users);
      commit('storeTicketNotes',  result.ticketNotes);
      return Promise.resolve(result.ticketNotes);
    })
    .catch(e => {
      console.log('state - tickets - actions.loadTicketNotes Error:', e);
      return Promise.reject(e);
    });
  },

  createTicketNote ({commit, dispatch}, params) {
    
    if (!params.property || !params.ticket || !params.note) {
      return Promise.reject('state.ticketNote - create Ticket Notes Missing required parameter - property: ' + !params.property + ', ticket: ' + !params.ticket, 'note:', params.note);
    }

    return window.server.postReq('/property/' + params.property + '/ticket/' + params.ticket + '/note', {
      note: params.note
    })
    .then(data => {
      var result = storeData([data]);
      commit('storeTicketNotes', result.ticketNotes);
      return Promise.resolve(result.ticketNotes[0]);
    })
    .catch(e => {
      return Promise.reject(e);
    })
  }
  
};

function storeData (notes) {

  // Break out and store what we can
  var users       = {};
  
  notes.forEach((note, i) => {

    if (note.createdBy && !(_.isString(note.createdBy))) {
      if (!(note.createdBy._id in users)) users[note.createdBy._id] = note.createdBy;
      notes[i].createdBy = note.createdBy._id;
    } 

  }); 

  users       = _.values(users);

  return {
    users,
    ticketNotes: notes
  };
};

export default {
  state,
  getters,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/ticketNote.js